export default "__VITE_ASSET__D3M4rAiQ__"